import type { App as VueApp, Plugin } from "vue";

const DataWebConfig: Plugin = {
    install(app: VueApp) {
    }
};

export default DataWebConfig;